import EditPlantCtrl from "app/admin/plants/ctrls";
import companyTpl from "app/admin/plants/templates/modal.html";
import defaultDelivery from "./templates/default_delivery.html";
import defaultCompany from "./templates/default_company.html";
import angular from 'angular';

export class DefaultDeliveryCtrl {
  constructor($growl, R, $uibModalInstance, deliveryOptions, $user) {
    "ngInject";
    this.R = R;
    this.$growl = $growl;
    this.$modal = $uibModalInstance;
    this.deliveryOptions = deliveryOptions;
    this.user = angular.copy($user);
    this.currentDefaultDelivery = this.deliveryOptions.find(
      (x) => x.value === this.user.default_delivery
    );
    if (this.currentDefaultDelivery) {
      this.currentDefaultDeliveryLabel = this.currentDefaultDelivery.label;
    }
  }

  get title() {
    return `Choose default delivery option`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    this.loading = true;
    this.user
      .patch({ default_delivery: this.user.default_delivery.value })
      .then(
        (response) => {
          angular.extend(this.user, response);
          this.$growl.success("Status Changed!");
          this.$modal.close();
          window.location.reload();
        },
        (response) => {
          if (response.status === 500) {
            this.$growl.error(response.data.detail);
          }
        }
      )
      .finally(() => (this.loading = false));
  }
}

export class DefaultCompanyCtrl {
  constructor($growl, R, $uibModalInstance, companyOptions, $user) {
    "ngInject";
    this.R = R;
    this.$growl = $growl;
    this.$modal = $uibModalInstance;
    this.companyOptions = companyOptions;
    this.user = angular.copy($user);
    this.currentDefaultCompany = this.companyOptions.find(
      (x) => x.value === this.user.default_company
    );
    if (this.currentDefaultCompany) {
      this.currentDefaultCompanyLabel = this.currentDefaultCompany.label;
    }
  }

  get title() {
    return `Choose default company option`;
  }

  close() {
    this.$modal.dismiss();
  }

  submit() {
    this.loading = true;
    this.user
      .patch({ default_company: this.user.default_company.value })
      .then(
        (response) => {
          angular.extend(this.user, response);
          this.$growl.success("Status Changed!");
          this.$modal.close();
          window.location.reload();
        },
        (response) => {
          if (response.status === 500) {
            this.$growl.error(response.data.detail);
          }
        }
      )
      .finally(() => (this.loading = false));
  }
}

export class HomeCtrl {
  constructor(CompanyStore, Modal, R, $growl, UserService) {
    "ngInject";
    this.$user = UserService.$user;
    this.store = CompanyStore;
    this.store.init();
    this.store.refresh();
    this.Modal = Modal;
    this.R = R;
    this.$growl = $growl;
  }

  syncAS400() {
    let self = this;
    let $modal = self.Modal.openConfirm({
      confirmName: "Yes",
      text: `Are you sure ?`,
    });
    $modal.wait.then(function (result) {
      self.R.all("sync_as400")
        .customPOST({})
        .then(
          function () {
            self.$growl.success("Syncing started.");
            result.close();
          },
          function () {
            self.$growl.error("Syncing already in progress.");
            result.close();
          }
        );
    });
  }

  chooseDefaultDelivery() {
    this.deliveryOptions = [
      { value: null, label: "No default delivery option" },
      { value: "haul", label: "Haul" },
      { value: "apply_haul", label: "Apply & Haul" },
      { value: "pickup", label: "Pick-Up" },
    ];
    let self = this;
    let $modal = this.Modal.open({
      template: defaultDelivery,
      controller: DefaultDeliveryCtrl,
      size: "small",
      resolve: {
        deliveryOptions: () => this.deliveryOptions,
        $user: () => this.$user,
      },
    });

    $modal.result.then(function () {
      self.$growl.updated();
    });
  }

  chooseDefaultCompany() {
    this.companyOptions = [{ value: null, label: "No default company" }]
    for (const company of this.$user.companies) {
      this.companyOptions.push({value: company.id, label: company.name})
    }
    let self = this;
    let $modal = this.Modal.open({
      template: defaultCompany,
      controller: DefaultCompanyCtrl,
      size: "small",
      resolve: {
        companyOptions: () => this.companyOptions,
        $user: () => this.$user,
      },
    });

    $modal.result.then(function () {
      self.$growl.updated();
    });
  }
}



export class CompanyHomeCtrl {
  constructor($growl, Modal, $company) {
    "ngInject";
    this.$growl = $growl;
    this.Modal = Modal;
    this.company = $company;
  }

  openModal() {
    let self = this;
    let $modal = this.Modal.open({
      template: companyTpl,
      controller: EditPlantCtrl,
      size: "small",
      resolve: {
        company: () => this.company,
      },
    });

    $modal.result.then(function () {
      self.$growl.updated();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/home/ctrls.js